import React, { useEffect } from 'react'
import Modal from 'antd/es/modal'
import Form from 'antd/es/form'
import Input from 'antd/es/input'
import Button from 'components/button'
import { CreateEmployeeVariables } from 'models'
import Notification from 'antd/es/notification'
import { positiveFloatRegex } from '../../../models'
import Select from 'antd/es/select'
import { Td } from '../../../components/table'

type Props = {
  visible: boolean
  onSave: (user: CreateEmployeeVariables) => void
  onCancel: () => void
}

export const AddNewEmployeeModal = (props: Props) => {
  const [form] = Form.useForm()

  const onFinish = (result: CreateEmployeeVariables) => {
    try {
      const validate = new CreateEmployeeVariables(result)
      props.onSave(validate)
    } catch (e) {
      console.log(e)
      Notification.error({ message: JSON.stringify(e) })
    }
  }

  useEffect(() => {
    form.resetFields()
  }, [props.visible])

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo)
  }

  return (
    <Modal
      visible={props.visible}
      title={'Lisää ' + global.Translations.get('employee')}
      onCancel={() => {
        props.onCancel()
      }}
      closable={false}
      closeIcon={false}
      footer={
        <Button.ButtonGroup style={{ justifyContent: 'flex-end' }}>
          <Button
            label="Peruuta"
            onClick={() => {
              props.onCancel()
            }}
            color="default"
          />
          <Button
            label="Tallenna"
            onClick={() => {
              form.submit()
            }}
            color="green"
          />
        </Button.ButtonGroup>
      }
    >
      <Form
        form={form}
        name="basic"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ remember: true }}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        {/* first name */}
        <Form.Item label={'Etunimi'} name="first_name" rules={[{ required: true, message: 'Anna etunimi!' }]}>
          <Input />
        </Form.Item>
        {/* last name */}
        <Form.Item label="Sukunimi" name="last_name" rules={[{ required: true, message: 'Anna sukunimi!' }]}>
          <Input />
        </Form.Item>
        {/* email */}
        <Form.Item
          label="Sähköposti"
          name="email"
          rules={[
            { required: true, message: 'Anna sähköposti!' },
            { type: 'email', message: 'Anna sähköposti!' }
          ]}
        >
          <Input />
        </Form.Item>
        {/* city */}
        <Form.Item
          initialValue={'pori'}
          name="city"
          label="Kaupunki"
          rules={[
            {
              message: 'Anna kaupunki',
              required: true
            }
          ]}
        >
          <Select placeholder="Kaupunki">
            <Select.Option value={'pori'}>Pori</Select.Option>
            <Select.Option value={'turku'}>Turku</Select.Option>
            <Select.Option value={'espoo'}>Espoo</Select.Option>
          </Select>
        </Form.Item>
        {/* Phone number */}
        <Form.Item label="Puhelinnumero" name="phone_number" hidden={true}>
          <Input />
        </Form.Item>
        {/* Roles */}
        <Form.Item hidden={true} initialValue={['Employee']} label="Roolit" name="roles">
          <Input />
        </Form.Item>
        {/* Password */}
        <Form.Item label="Salasana" name="password" hidden={true} rules={[{ required: false, message: 'Anna salasana!' }]}>
          <Input.Password />
        </Form.Item>
        <Form.Item label="Sotu" name="social_number" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item label="Työnimike" name="job_tittle" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item label="Osoite" name="address" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item label="Tuntihinta" name="hour_rate" hidden={true}>
          <Input />
        </Form.Item>
        <Form.Item label="Tilinumero" name="bank_account" hidden={true}>
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default AddNewEmployeeModal
